require('./scheduleSearchService');
require('../../favorites/favoritesService');

'use strict';

angular.module('app.schedule.scheduleSearch.scheduleSearchController', [
  'app.schedule.scheduleSearch.scheduleSearchService',
  'app.favorites.favoritesService',
  'daterangepicker',
])
  .controller('app.schedule.scheduleSearch.scheduleSearchController', [
    '$scope',
    'app.schedule.scheduleSearch.scheduleSearchService',
    'app.favorites.favoritesService',
    '$rootScope',
    '$state',
    'PRODUCT',
    function ($scope, scheduleSearchService, favorites, $rootScope, $state, product) {
      let ignoreTermChange = false; //used to avoid triggering watch when manually setting search term

      $scope.name = $scope.name || null;
      $scope.scheduleSearch = scheduleSearchService.scheduleSearch;
      $scope.group = 'teams';

      $scope.showTermResults = $scope.showTermResults || false;
      $scope.hideDateSelector = $scope.hideDateSelector || false;
      $scope.hideFavoritesSelector = $scope.hideFavoritesSelector || false;
      $scope.hideTerm = $scope.hideTerm || false;
      $scope.onSelected = $scope.onSelected || false;
      $scope.showInstructions = $scope.showInstructions || false;
      $scope.termListTitle = $scope.termListTitle || 'Search Results';
      $scope.alwaysOpen = $scope.alwaysOpen || false;

      $scope.favorites = favorites;
      $scope.favoriteTerms = null;
      $scope.userSelected = false;
      $scope.displayDateText = moment().toDate();

      $scope.productName = product.Name;
      $scope.productId = product.Id;

      $scope.isFavouritesManager = $scope.isFavouritesManager || false;

      $scope.scheduleSearch.custom_date = {};

      $scope.datePicker = {};
      $scope.datePicker.date = {startDate: $scope.scheduleSearch.custom_date.start, endDate: $scope.scheduleSearch.custom_date.end};
      $scope.datePicker.opts = {
        showDropdowns: true,
        minDate: moment("2012-08-01"),  // oldest game date with video in htv
        linkedCalendars: false,
        opens: "center",
        parentEl: ".selection-calendar",
        alwaysShowCalendars: true,
        ranges: {
          'Today': [moment(), moment()],
          'This Week': [moment().startOf('week'), moment().endOf('week')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Next 7 Days': [moment(), moment().add(6, 'days')]
        },
        eventHandlers: {
          'apply.daterangepicker': function() {
            $scope.scheduleSearch.custom_date.start = $scope.datePicker.date.startDate;
            $scope.scheduleSearch.custom_date.end = $scope.datePicker.date.endDate;
            $scope.search_custom_date_range();
          },
          'cancel.daterangepicker': function() { $scope.cancel_custom_search(); },
        }
      };

      let getFavoriteTerms = function () {
        if (favorites.list && Array.isArray(favorites.list.personal)) {
          $scope.favoriteTerms = [];
          for (let i in favorites.list.personal) {
            if (favorites.list.personal.hasOwnProperty(i)) {
              let favorite = favorites.list.personal[i];
              if (favorite.term) {
                $scope.favoriteTerms.push(favorite.term);
              }
            }
          }
        }
      };

      $scope.clear_term = function (ignoreOnSelected) {
        if($scope.scheduleSearch.term) {
          $scope.scheduleSearch.clear_term();
          if(!$scope.isFavouritesManager) {
            $scope.scheduleSearch.search_schedule();
          }
        }

        $scope.showTermResults = false;

        if (!ignoreOnSelected) {
          if (typeof $scope.onSelected === 'function') {
            $scope.onSelected();
          }
        }
      };

      $scope.outerSearchPanelClicked = function (type, searchId, evt) {
        if ($scope.isFavouritesManager) {
          favorites.toggle(type, searchId);
          $scope.clear_term();
          evt.stopPropagation();
        }
      };

      $scope.manually_set_search_term = function (term) {
        ignoreTermChange = true;
        $scope.scheduleSearch.term = term;
      };

      $scope.select_term = function (term, sort_direction) {
        if ($scope.isFavouritesManager && favorites.is_favorite(term.type, term.search_id)) {
          $state.go('app.schedule', {selected_favorites: favorites.find_favorite(term.type, term.search_id)}, {
            inherit: false,
            reload: false
          });
        } else {
          $rootScope.$broadcast("favorites_reset_all_leagues");
          $rootScope.$broadcast("schedule_search_select_term");

          $scope.scheduleSearch.set_term(term.type, term.search_id, term.term ? term.term : term.label);

          if(!$scope.isFavouritesManager) {
            $scope.scheduleSearch.use_custom_date = true;
            $scope.scheduleSearch.set_custom_date_sort_direction();
            $scope.scheduleSearch.search_schedule();
          }

          $scope.showTermResults = false;

          $scope.manually_set_search_term(term.term ? term.term : term.label);

          if (typeof $scope.onSelected === 'function') {
            $scope.onSelected(term);
          }
        }
      };

      $scope.change_day = function (days_to_move) {
        let start;
        if ($scope.scheduleSearch.custom_date.start != null) {
          start = moment($scope.scheduleSearch.custom_date.start);
        } else {
          start = moment();
        }

        start = start.add(days_to_move, 'days').toDate();
        $scope.scheduleSearch.set_custom_date(start, start);
        $rootScope.$broadcast('schedule_search_select_term');
        $scope.scheduleSearch.use_current_time = true;
        $scope.scheduleSearch.search_schedule();
      };

      $scope.toggle_custom_date_display = function () {
        $scope.scheduleSearch.use_custom_date = true;
        $scope.scheduleSearch.show_custom_date_selector = !$scope.scheduleSearch.show_custom_date_selector;
      };

      $scope.open_custom_search = function () {
        let start = $scope.scheduleSearch.get_date().start,
          end = $scope.scheduleSearch.get_date().end;

        $scope.scheduleSearch.custom_date.start = start ? moment(start) : undefined;
        $scope.scheduleSearch.custom_date.end = end ? moment(end) : undefined;
        $scope.toggle_custom_date_display();
      };

      $scope.cancel_custom_search = function () {
        $scope.toggle_custom_date_display();
      };

      $scope.search_custom_date_range = function () {
        $scope.toggle_custom_date_display();
        $scope.scheduleSearch.custom_date_title = null;
        $scope.scheduleSearch.schedule_params.status = null;//fixes issue where if user searches by past games then custom date it retains the status value.
        $scope.scheduleSearch.schedule_params.sort = null; //fixes sorting issue when searching by past games then custom dates
        $rootScope.$broadcast('schedule_search_select_term'); //reset page to 1 when switching between dates/days
        $scope.scheduleSearch.use_current_time = false;
        $scope.scheduleSearch.search_schedule();
      };

      $scope.search_all_future_dates = function () {
        $scope.toggle_custom_date_display();
        $scope.scheduleSearch.set_custom_date(moment(), null);
        $rootScope.$broadcast('schedule_search_select_term');
        $scope.scheduleSearch.use_current_time = true;
        $scope.scheduleSearch.search_schedule('asc');
      };

      $scope.search_all_past_dates = function () {
        $scope.toggle_custom_date_display();
        $scope.scheduleSearch.set_custom_date(null, moment());
        $rootScope.$broadcast('schedule_search_select_term');
        $scope.scheduleSearch.use_current_time = false;
        $scope.scheduleSearch.search_schedule('desc');
      };

      $scope.searchResults = function () {
        if ($scope.scheduleSearch && $scope.scheduleSearch.term) {
          return $scope.scheduleSearch.results[$scope.group];
        }
        else if (favorites.list) {
          if (!$scope.favoriteTerms) {
            getFavoriteTerms();
          }
          return $scope.favoriteTerms;
        }
      };

      $scope.toggleFavorite = function (type, search_id, event) {
        $scope.favorites.toggle(type, search_id);
        if ($scope.isFavouritesManager) {
          $scope.clear_term();
          event.stopPropagation();
        }
      };

      $scope.termChanged = () => {
        if(!ignoreTermChange) {
          ignoreTermChange = $scope.scheduleSearch.schedule_params &&
            $scope.scheduleSearch.schedule_params.search_term &&
            $scope.scheduleSearch.schedule_params.search_term === $scope.scheduleSearch.term;
        }

        if (!ignoreTermChange) {
          if ($scope.scheduleSearch.term && $scope.scheduleSearch.term.length >= 3) {

            $scope.scheduleSearch.search_terms([$scope.group]);
            if ($scope.scheduleSearch.term) {
              return $scope.showTermResults = true;
            } else {
              return $scope.showTermResults = false;
            }
          } else {
            return $scope.showTermResults = false;
          }
        } else {
          ignoreTermChange = false;
        }
      };

      $scope.$watch(function () {
        return $scope.showTermResults;
      }, function () {
        $scope.$emit('scheduleSearchTermVisibilityChanged', {
          isVisible: $scope.showTermResults
        });
      });

      $scope.$watchGroup([
        'scheduleSearch.use_custom_date',
        'scheduleSearch.date_offset.start',
        'scheduleSearch.date_offset.end',
        'scheduleSearch.custom_date.start',
        'scheduleSearch.custom_date.end'
      ], function () {
        $scope.scheduleSearch.set_custom_date_text()
      });

      $scope.$on('favorites_selected', function () {
        $scope.scheduleSearch.clear_term();
      });

      $scope.$on('favorites_changed', function () {
        getFavoriteTerms();
      });

      $scope.$on('favorites_updated', function () {
        getFavoriteTerms();
      });

      $scope.$on('reinit_schedule_search', () => {
        $scope.scheduleSearch.init();
      });

      $scope.$on('assign_schedule_search_group', () => {
        if($scope.scheduleSearch.schedule_params && $scope.scheduleSearch.schedule_params.hasOwnProperty('type')) {
          switch ($scope.scheduleSearch.schedule_params.type) {
            case 'team':
            default:
              $scope.group = 'teams';
              break;
            case 'league':
              $scope.group = 'leagues';
              break;
            case 'event':
              $scope.group = 'events';
              break;
          }
        }
      });

      let promise = favorites.retrieve_if_empty();
      if (!promise) {
        getFavoriteTerms();
      }

      $scope.scheduleSearch.init();

      $scope.$on('$destroy', function () {
        $scope.scheduleSearch.show_custom_date_selector = false;
        $scope.scheduleSearch.custom_date.start = null;
        $scope.scheduleSearch.custom_date.end = null;
        $scope.scheduleSearch.custom_date_title = null;
        $scope.scheduleSearch.schedule_params = null;
        $scope.scheduleSearch.term = null;
      });
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/schedule/scheduleSearch/scheduleSearchController.js